import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr2020',
    ecrans: ['00-2'],
    params: ['id', 'cyrcleint']
});
